export enum ETicketStatus {
  ACTIVE = 'ACTIVE',
  IN_PROGRESS = 'IN_PROGRESS',
  DECLINED = 'DECLINED',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  WAITING_FOR_REQUISITE = 'WAITING_FOR_REQUISITE',
  WAITING_FOR_SMS = 'WAITING_FOR_SMS',
  WAITING_FOR_MERCHANT = 'WAITING_FOR_MERCHANT',
  WAITING_FOR_ACTION = 'WAITING_FOR_ACTION',
  NOT_CONFIRMED = 'NOT_CONFIRMED',
  CLIENT_PENDING = 'CLIENT_PENDING',
  ADAPTER_PENDING = 'ADAPTER_PENDING',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  FILES_AUTO_VERIFICATION = 'FILES_AUTO_VERIFICATION',
  FILES_VERIFICATION = 'FILES_VERIFICATION',
  EXPIRED = 'EXPIRED',
  /** Concierge deposit waiting for staff to set its method and run the search. */
  MANUAL_REQUISITE = 'MANUAL_REQUISITE',
}

/**
 * Бизнес-статусы (группы) тикета для мерчантских ролей — оператор / старший оператор.
 * Backend разворачивает группу во внутренние статусы (см. App\Ticket\TicketStatusGroup).
 * Отправляются в API как statusGroup[].
 */
export enum ETicketStatusGroup {
  ACTIVE = 'ACTIVE',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
}

export enum ETicketFinishedStatus {
  DECLINED = 'DECLINED',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
}

export enum EPayoutTicketStatus {
  PLACEMENT_PENDING = 'PLACEMENT_PENDING',
  ACTION_PENDING = 'ACTION_PENDING',
  PAYOUT_PENDING = 'PAYOUT_PENDING',
  CONFIRMATION_PENDING = 'CONFIRMATION_PENDING',
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
}

export enum ETransactionStatus {
  ACTIVE = 'ACTIVE',
  IN_PROGRESS = 'IN_PROGRESS',
  DECLINED = 'DECLINED',
  COMPLETED = 'COMPLETED',
}

export enum ERequisiteEvent {
  CANCEL_RESERVATION = 'CANCEL_RESERVATION',
  CREATE = 'CREATE',
  CREATE_RESERVATION = 'CREATE_RESERVATION',
  ENABLE_RESERVATION = 'ENABLE_RESERVATION',
  DISABLE_RESERVATION = 'DISABLE_RESERVATION',
  COMPLETE_RESERVATION = 'COMPLETE_RESERVATION',
  AUTO_CANCEL_RESERVATION = 'AUTO_CANCEL_RESERVATION',
  AUTO_COMPLETE_RESERVATION = 'AUTO_COMPLETE_RESERVATION',
  HIDDEN = 'HIDDEN',
}

// export enum EPaymentMethods {
//   MC_VISA_UAH = 'MC/VISA UAH',
//   PRIVAT24_P2P_UAH = 'PRIVAT24 P2P UAH',
//   MC_VISA_MIR_P2P_RUB = 'MC/VISA/MIR P2P RUB',
//   SBP_P2P_RUB = 'SBP P2P RUB',
//   MC_VISA_P2P_KZT = 'MC/VISA P2P KZT',
//   MOBILE_P2P_KZT = 'MOBILE P2P KZT',
// }

export enum EFileStatus {
  PROCESSING = 'PROCESSING',
  REJECTED = 'REJECTED',
  VERIFIED = 'VERIFIED',
}

export enum EFileBadgeStatus {
  PROCESSING    = 'processing',
  PENDING       = 'pending',  
  APPROVED      = 'approved',
  REJECTED      = 'rejected',
  NEEDS_REVIEW  = 'needs_review',  
  ERROR         = 'error',
  DISABLED      = 'disabled',
}

export enum EMatchingPaymentTicketStatus {
  CREATED = 'CREATED',
  ACTIVE = 'ACTIVE',
  WAITING_FOR_REQUISITE = 'WAITING_FOR_REQUISITE',
  WAITING_FOR_SMS = 'WAITING_FOR_SMS',
  WAITING_FOR_MERCHANT = 'WAITING_FOR_MERCHANT',
  WAITING_FOR_ACTION = 'WAITING_FOR_ACTION',
  CLIENT_PENDING = 'CLIENT_PENDING',
  ADAPTER_PENDING = 'ADAPTER_PENDING',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  NOT_CONFIRMED = 'NOT_CONFIRMED',
  FILES_AUTO_VERIFICATION = 'FILES_AUTO_VERIFICATION',
  FILES_VERIFICATION = 'FILES_VERIFICATION',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  COMPLETED = 'COMPLETED',
}

export enum EMatchingPayoutTicketStatus {
  CREATED = 'CREATED',
  ACTIVE = 'ACTIVE',
  PLACEMENT_PENDING = 'PLACEMENT_PENDING',
  ADAPTER_PENDING = 'ADAPTER_PENDING',
  ACTION_PENDING = 'ACTION_PENDING',
  PAYOUT_PENDING = 'PAYOUT_PENDING',
  MATCHING_PROCESSING = 'MATCHING_PROCESSING',
  CONFIRMATION_PENDING = 'CONFIRMATION_PENDING',
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
}

export enum EMatchingStatus {
  PROCESSING = 'PROCESSING',
  HALTED = 'HALTED',
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
}
